module.exports = __webpack_public_path__ + "static/media/dhaam_logo.b5e3c9f3.webp";